var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"prop":"name","label":"组件名称：","label-width":"110px"}},[_vm._v("\n        "+_vm._s(_vm.field.name + '组件')+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }